import Model from "./Model";

export default class FichaIndividualAee extends Model {
  constructor(ficha) {
    super();
    Object.assign(this, ficha);
  }
}
